import { AppLayoutResource } from './../../../../models/src/resources/AppLayoutResource';
import { TourResource } from '@aorg/models/resources/Tour/TourResource';
import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';
import { InfoCardTypeResource } from './../../../../models/src/resources/InfoCard/InfoCardTypeResource';
import { set } from 'lodash';

const initialState: {
  infocardTypes: InfoCardTypeResource[];
  requestedPush: boolean;
  tours: TourResource[];
  homeLayout?: AppLayoutResource;
  resourceLayout?: AppLayoutResource;
} = {
  infocardTypes: [],
  requestedPush: false,
  tours: [],
  homeLayout: undefined,
  resourceLayout: undefined,
};

const setup = createSlice({
  name: 'appcache',
  initialState,
  reducers: {
    setInfoCardTypes(
      state,
      { payload }: PayloadAction<InfoCardTypeResource[]>
    ) {
      return { ...state, infocardTypes: payload };
    },
    setRequestedPush(state, { payload }: PayloadAction<boolean>) {
      return { ...state, requestedPush: payload };
    },
    setTours(state, { payload }: PayloadAction<TourResource[]>) {
      return { ...state, tours: payload };
    },
    setHomeLayout(state, { payload }: PayloadAction<AppLayoutResource>) {
      return { ...state, homeLayout: payload };
    },
    setResourceLayout(state, { payload }: PayloadAction<AppLayoutResource>) {
      return { ...state, resourceLayout: payload };
    },
    cleanCache() {
      return initialState;
    },
  },
});

export const {
  setTours,
  setInfoCardTypes,
  setRequestedPush,
  setHomeLayout,
  setResourceLayout,
  cleanCache,
} = setup.actions;

export const selectInfoCardType = ({ appcache }: RootState) =>
  appcache.infocardTypes;
export const selectRequestedPush = ({ appcache }: RootState) =>
  appcache.requestedPush;
export const selectToursList = ({ appcache }: RootState) => appcache.tours;
export const selectHomeLayout = ({ appcache }: RootState) =>
  appcache.homeLayout;
export const selectResourceLayout = ({ appcache }: RootState) =>
  appcache.resourceLayout;

export default setup.reducer;
